import { render, staticRenderFns } from "./ModalTerm.vue?vue&type=template&id=54e588f8&scoped=true"
import script from "./ModalTerm.vue?vue&type=script&lang=js"
export * from "./ModalTerm.vue?vue&type=script&lang=js"
import style0 from "./ModalTerm.vue?vue&type=style&index=0&id=54e588f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e588f8",
  null
  
)

export default component.exports